<template>
  <div class="wrapper container">
    <div class="content">
      <h2><span class="pingfang-family">TGO</span> 鲲鹏会学员培训章程</h2>
      <div class="new-member">
        <h4>新学员培训</h4>
        <p class="link">（欢迎移步 TGO 鲲鹏会学员专属 Tower 社区讨论交流，链接 <a href="https://tower.im/teams/612908/todos/4783/">TGO 鲲鹏会新学员培训的意义是什么？</a>）</p>
        <p>TGO 鲲鹏会新学员培训的意义是什么？所有学员都需要参加的必要性是什么？</p>
        <p>和一群技术管理者（TGO 鲲鹏会）在一起，如何提升自己的领导力，“领导一群领导者”？2019 版的新学员培训将教授领导力工具（约哈里窗、结构化的会议、教练技术、深度破冰、一字晴雨表、月度回顾等），可以用于小组，也可以用于工作和家庭中。</p>
        <p>通过现场模拟，体验结构化会议和仪式感，加深对于小组活动和规则流程的理解和认识。</p>
        <p>正本清源地了解 TGO 鲲鹏会是个什么样的组织：不是一个技术组织、不是一个社交组织，是一个学习平台。</p>
        <p>如何实现同侪学习和小组成员间的人生叠加？</p>
        <p>小组是 TGO 鲲鹏会权益的一部分，TGO 鲲鹏会还有哪些权益？TGO 鲲鹏会未来 1-3 年提供哪些新的权益？</p>
        <p>这些是在新学员培训中要解决的问题。</p>
        <p class="link">新学员培训的教材可以在学员专属 Tower 社区看到，链接 <a href="https://tower.im/teams/612908/todos/755/">TGO 鲲鹏会新学员培训教材-TGO 鲲鹏会总部-2019年9月</a></p>
      </div>
      <div class="group-leader">
        <h4>领导力培训</h4>
        <p class="link">（欢迎移步 TGO 鲲鹏会学员专属 Tower 社区讨论交流，链接 <a href="https://tower.im/teams/612908/todos/4784/">TGO 鲲鹏会领导力培训的起因和价值是什么？</a>)</p>
        <h6>1. 小组背景</h6>
        <p>自 2015 年成立以来，TGO 鲲鹏会累计共成立了 84 个小组。有的小组“存活”不到一年、成员认为加入 TGO 鲲鹏会的价值低于预期，有的小组“持续”了 4 年、每个月都能全员参加小组活动、小组成员个人能力&家庭&工作&财务上都有很好的收获。造成这些差异的原因是什么？我们希望能够传递各个小组的经验教训，让小组成为可以维系二十年的战斗堡垒。</p>

        <h6>2. 基于小组提升领导力</h6>
        <p>撇开其他因素，小组活动情况和小组成员体验，在一定程度上是组长的领导力的体现。和一群技术管理者（TGO 鲲鹏会学员）在一起，如何提升自己的领导力？ TGO 鲲鹏会小组是一个绝佳的锻炼领导能力的“沙箱”，每个人都有机会在这里“领导一群领导者”，TGO 鲲鹏会有一整套经验和工具（约哈里窗、结构化的会议、教练技术、深度破冰、一字晴雨表、月度回顾等），可以用于小组，也可以用于工作和家庭中。</p>

        <h6>3. 小组特性：同侪学习+经验叠加</h6>
        <p> TGO 鲲鹏会的小组是成员固定的、私密不对外的。为什么小组话题枯竭的情况“不应该”出现？在技术架构、行业特性、个人经历之外，还可以讨论哪些？</p>
        <p>从约哈里窗的四象限来看，小组讨论的话题主要是突破盲点、挖掘潜能，因此在工作相关话题之外，个人认知提升、能力拓展、未来规划、儿时的梦想……都是小组讨论的主题，每个人可以通过小组体验到 8 种不一样的人生，并且不是一个小片段，而是完整的“经验的叠加”。这其中有诸多注意事项和正方两方面的经验，希望通过领导力培训来传递。</p>
        <h6>4. 不仅是现任组长，而且是每位学员都需要</h6>
        <p>依据小组章程，TGO 鲲鹏会小组组长应该每年进行换届；只有参加过领导力培训的学员才可以担任组长并享受相应权益。 </p>
        <p>更重要的是，领导力培训提供了一整套领导力方法和工具，这是可以广泛应用的，也是 TGO 鲲鹏会学员权益的一部分，因此强烈建议所有学员都参加。 </p>

        <h6>5. 总结</h6>
        <p>领导力培训的这些经验和工具，是基于 TGO 鲲鹏会运营历史，并参考了其他组织而来的；在北京已经进行的 2 场培训中，学员 NPS 值为 68%，也证实了学员对于培训内容的认可。 </p>
        <p>和管理方法/管理工具类似，TGO 鲲鹏会小组也有一些值得分享的实践、提升领导力的案例、建立成员深度链接的实用工具，这些是我们希望所有学员通过领导力培训获得的价值。</p>

        <p class="link">领导力培训的教材可以在学员专属 Tower 社区看到，链接 <a href="https://tower.im/teams/612908/todos/3506/">TGO 鲲鹏会领导力培训PPT-TGO 鲲鹏会总部-2019年9月</a></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='sass'>
  @import "../../style/bulma/app.sass"
  .content
    width: 775px
    margin: 0 auto
    margin-bottom: 40px
    +mobile
      width: 100%
    h2
      margin-top: 64px
      font-weight: bold
    h6
      font-weight: bold
      margin-top: 30px
    .new-member,.group-leader
      padding-top: 40px
      h4
        font-weight: bold
        border-left: 3px solid $primary3
        padding-left: 10px
        margin-bottom: 18px
      p
        line-height: 2
    .group-leader
      padding-top: 40px
  .pingfang-family
    font-family: PingFang SC
</style>
